import { ArrowUpRight, FileText } from "lucide-react";

import type { Message } from "@/api/db/messages";
import { ImagePreview } from "@/components/ui/image-preview";
import { MediaUnavailable } from "@/components/ui/media-unavailable";
import { MessageRender } from "@/lib/message-render";

import { MessageAudio } from "./message-audio";

export function MessageContent({ message }: { message: Message }) {
	const src = message.media_gone ? null : `/media/${encodeURIComponent(message.id)}`;

	if (message.type === "audio") {
		return <MessageAudio src={src} transcription={message.transcription} />;
	}

	if (!MessageRender.hasMedia(message)) {
		return <p className="whitespace-pre-wrap break-words">{MessageRender.body(message)}</p>;
	}

	const caption = message.text ?? message.media_description;

	return (
		<div className="flex flex-col gap-2">
			{message.type === "image" && <ImagePreview src={src} alt="Imagem da conversa" />}
			{message.type !== "image" && (
				<>
					{!src && <MediaUnavailable kind="file" />}
					{src && (
						<a
							href={src}
							target="_blank"
							rel="noreferrer"
							data-slot="bubble-media"
							className="flex min-h-16 w-64 max-w-full items-center gap-3 rounded-md py-2 text-primary transition-colors hover:text-primary-hover focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
						>
							<span className="grid size-10 shrink-0 place-items-center rounded-lg bg-primary/10">
								<FileText className="size-5" aria-hidden="true" />
							</span>
							<span className="flex-1 text-sm font-medium">Abrir arquivo</span>
							<ArrowUpRight className="size-4" aria-hidden="true" />
						</a>
					)}
				</>
			)}
			{caption && <p className="whitespace-pre-wrap break-words">{caption}</p>}
		</div>
	);
}
